enum TechnologyCategory {
    FRONTEND,
    BACKEND,
    DEVOPS,
    MOBILE,
    LANGUAGE,
    TOOLS,
}

export default TechnologyCategory